import { IUseLoyaltyRewards, UseLoyaltyRewards } from 'state/loyalty/hooks/types';

export const useLoyaltyRewards: UseLoyaltyRewards = () => {
  return {
    appliedLoyaltyRewards: {},
    availableLoyaltyRewardsMap: {},
    appliedLoyaltyRewardsArray: null
  } as IUseLoyaltyRewards;
};
